import React from "react";
import { Departments, type Person } from "../schema";
import JoinSelector from "./JoinSelector";
import PersonCard from "./PersonCard";

export interface Props {
  members: Person[];
  displayed: string;
}

export default function PersonGrid({ members, displayed }: Props) {
  return (
    <div className="grid lg:grid-cols-12 grid-cols-4 gap-y-3.5 gap-x-4 lg:gap-8 w-full">
      {members.length > 3 ? (
        members.map((member, index) => {
          return index === 2 ? (
            <React.Fragment key={member.id}>
              <PersonCard person={member} />
              {displayed !== Departments.principals && displayed !== Departments.innovators && (
                <JoinSelector displayed={displayed} />
              )}
            </React.Fragment>
          ) : (
            <PersonCard key={member.id} person={member} />
          );
        })
      ) : (
        <React.Fragment>
          {members.map((member) => {
            return <PersonCard key={member.id} person={member} />;
          })}
          {displayed !== Departments.principals && displayed !== Departments.innovators && (
            <JoinSelector displayed={displayed} />
          )}
        </React.Fragment>
      )}
    </div>
  );
}
